import { combineEpics } from 'redux-observable';
import { fetchAllPublicAuditLogsEpic } from './fetch-all-audit-logs.epic';

export const combinedPublicAuditLogEpics = combineEpics(
    fetchAllPublicAuditLogsEpic,
);
